import React, { createContext, useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/style.css';
import Navbar from '../components/Navbar.js';
import Home from '../components/Home.js';
import Projects from '../components/Projects.js';
import Expertise from '../components/Expertise.js';
import IndustryExperience from '../components/IndustryExperience.js';
import Contact from '../components/Contact.js';
import ParticleBackground from '../components/ParticleBackground.js';
import ProfessionalExperience from '../components/ProfessionalExperience';
import { PageMetadata, RouteScroll } from '../components/PageMetadata';
import ArticlesPage from './ArticlesPage';
import OpenSourcePage from './OpenSourcePage';
import SpeakingPage from './SpeakingPage';
import ImpactPage from './ImpactPage';
import { heroData } from '../data/siteData';

export const ThemeContext = createContext(null);

function App() {
  const [theme, setTheme] = useState('dark');
  const [activeSection, setActiveSection] = useState('home');
  const [isLoading, setIsLoading] = useState(true);

  const themeToggler = () => {
    setTheme((curr) => (curr === "dark" ? "light" : "dark"));
  };

  // Simulate loading
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <motion.div 
          className="loading-content"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="loading-avatar">
            <img src="/logo.png" alt="Elena Nurullina" />
          </div>
          <h1>Elena Nurullina</h1>
          <p>{heroData.title}</p>
          <div className="loading-bar">
            <motion.div 
              className="loading-progress"
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{ duration: 1.8, ease: "easeInOut" }}
            />
          </div>
          <p className="loading-text">Loading amazing experiences...</p>
        </motion.div>
      </div>
    );
  }

  return (
    <ThemeContext.Provider value={{ theme, themeToggler, activeSection, setActiveSection }}>
      <div className={`app ${theme}`} id={theme}>
        <ParticleBackground />
        <Navbar />
        
        <RouteScroll />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<>
              <PageMetadata title="Elena Nurullina | Full-Stack & AI Engineer" description="Full-stack engineering, intelligent automation, healthcare technology, financial systems, and technical product delivery." />
              <Home />
              <IndustryExperience />
              <Expertise />
              <Projects />
              <ProfessionalExperience />
              <Contact />
            </>} />
            <Route path="/articles" element={<ArticlesPage />} />
            <Route path="/open-source" element={<OpenSourcePage />} />
            <Route path="/speaking" element={<SpeakingPage />} />
            <Route path="/impact" element={<ImpactPage />} />
            <Route path="*" element={<div className="container page-content"><PageMetadata title="Page Not Found | Elena Nurullina" description="Return to Elena Nurullina's portfolio." /><h1>Page not found</h1><a href="/">Back to Home</a></div>} />
          </Routes>
        </main>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;